<template>
  <section class="content">
    <!-- Default box -->
    <div class="box">
            <div class="box-header">
              <h3 class="box-title">Report</h3>
              <hr>
            </div>
            <!-- /.box-header -->
            <div class="box-body" style="min-height: 800px">
              <div id="example1_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <div class="box-header with-border" style="background-color: #f1f1f1;">Detailed List</div> -->
                    <div class="box-header with-border" style="padding: 11px;padding-right: 0px;">
                      <h3 class="box-title"></h3>
                      <div class="box-tools" style="width: 500px;">
                        <Datepicker
                        v-model="selectedDate" position="right" lang="en"
                        range/>
                        <div>
                          <export-excel name="scheduleList" :data="json_data">
                            <a href="javascript:void(0)" @click="open()" class="btn btn-sm btn-primary pull-right">Export</a>
                          </export-excel>
                          <button class="mr-2 btn btn-sm sbtn pull-right" @click="getDate()">Apply</button>
                          <button class="mr-2 btn btn-sm btn-default pull-right" @click="clearData()">Clear</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div style="margin-top: 20%;text-align:center" v-if="userslistlength < 1">
                      <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                    </div>
                    <div class="table-responsive text-nowrap">
                  <table v-if="userslistlength > 0" id="example1" class="table table-striped" role="grid" aria-describedby="example1_info">
                <thead>
                  <tr role="row">
                    <th class="sorting_asc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending" style="width: 44px;">S.No</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending" style="width: 175.099px;">Post Title</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending" style="width: 145px;">Organization Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending" style="width: 145px;">Client Name </th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Engine version: activate to sort column ascending" style="width: 119.19px;">Interviewer Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending" style="width: 83.3665px;">Interview Date & Time</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending" style="width: 83.3665px;">Meeting ID</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending" style="width: 83.3665px;">Candidate Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending" style="width: 83.3665px;">Candidate Email</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending" style="width: 83.3665px;">Candidate Resume</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending" style="width: 83.3665px;">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr role="row" class="odd" v-for="(x, index) in userslist" :key="x">
                    <td>{{pageOfItems + index }}</td>
                    <td>{{x.job_tittle}}</td>
                    <td>{{x.org_name}}</td>
                    <td>{{x.client_name}}</td>
                    <td>{{x.interviewer_name}}</td>
                    <td>{{x.schedule_start_time}}</td>
                    <td>{{x.meeting_id}}</td>
                    <td>{{x.candidate_name}}</td>
                    <td>{{x.candidate_email}}</td>
                    <td><a :href="x.candidate_resume">Download</a></td>
                    <td>
                      <span v-if="x.status == 'Schedule Request'"><a style="color:black" @click="showPanels(x._id)">{{x.status}}</a></span>
                      <span v-else>{{x.status}}</span>
                    </td>
                  </tr>
                </tbody>
              </table></div></div></div>
              <div class="row" v-if="totalPages > 9">
                <div>
                  <div class="dataTables_info" id="example1_info" role="status" aria-live="polite"></div>
                </div>
                <div class="col-sm-12 tc">
                  <jw-pagination :items="pages" @changePage="onChangePage"></jw-pagination>
                </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <div class="modal overlay fade in" id="modal-default" style="display: block;" v-show="showInterviewersListModal">
            <div class="modal-dialog" role="document">
              <div class="modal-content AvailabilityPopup">
                <div class="modal-header">
                  <h3 class="modal-title">
                    <span>Invited Interviewers</span>
                    <button
                      type="button"
                      class="close"
                      @click="onClose()"
                    >
                      <span aria-hidden="true" class="modalClose">&times;</span>
                    </button>
                  </h3>
                </div>
                <div class="modal-body" style="padding:0px">
                  <div class="row" >
                    <div class="col-md-12 " style="padding:17px">
                      <div class="col-md-12">
                        <p style="font-size: 18px;font-weight: 400; text-align: start;" v-if="interviewersListErrorMsg!=''">{{interviewersListErrorMsg}}</p>
                        <div class="col-sm-12" v-else>
                          <div class="table-responsive text-nowrap">
                            <table id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size: 12px;">
                              <thead>
                                <tr role="row" style="text-align: center">
                                  <th rowspan="1" colspan="1">ID</th>
                                  <th rowspan="1" colspan="1">Interviewer Name</th>
                                  <th rowspan="1" colspan="1">Phone</th>
                                  <th rowspan="1" colspan="1">Accepted Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr role="row" class="odd" v-for="(x, ind) in interviewersList" :key="ind">
                                  <td>{{x.user_id}}</td>
                                  <td>{{x.user_name}}</td>
                                  <td>{{x.mobile_number}}</td>
                                  <td>{{x.accepted_status}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer" style="text-align: center;">
                  <button class="btn btn-success" @click="onClose()">Ok</button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
          </div>
  </section>
</template>

<script>

import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import excel from 'vue-excel-export'
import router from '../../router/index'
import Vue from 'vue'
import JwPagination from 'jw-vue-pagination'
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import moment from 'moment'
Vue.component('Datepicker', VueDatepickerUi)
Vue.component('jw-pagination', JwPagination)
Vue.use(excel)
export default {
  name: 'tabs-card',
  data () {
    return {
      title: '',
      pageOfItems: [],
      totalPages: 0,
      pages: [],
      showlist: false,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      viewdetails: false,
      adduser: true,
      userslistlength: '',
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      json_data: [],
      email: '',
      startDate: '',
      endDate: '',
      interviewersList: [],
      showInterviewersListModal: false,
      interviewersListErrorMsg: '',
      selectedDate: []
    }
  },
  created () {
    this.email = this.userInfo.user_email
    this.getPostdata()
    this.getalldata()
    this.$root.$emit('navigate', 'SheduleReport')
  },
  methods: {
    clearData () {
      this.selectedDate = []
      this.startDate = ''
      this.endDate = ''
      this.getPostdata()
    },
    getDate (e) {
      console.log(e)
      this.startDate = moment(this.selectedDate[0]).format('YYYY-MM-DD')
      this.endDate = moment(this.selectedDate[1]).format('YYYY-MM-DD')
      this.getPostdata()
    },
    getalldata () {
      let mainurl = ''
      // if (this.email === 'poojasingh@quesscorp.com' || this.email === 'rinu.jaison@quesscorp.com') {
      if (this.email.split('@')[1] === 'quesscorp.com') {
        mainurl = '/dashboard/get_schedule_report_quesscorp/' + this.userInfo._id + '/0'
      } else {
        mainurl = '/dashboard/get_schedule_report/0'
      }
      axios.get(`${BaseURL}${mainurl}`, this.config).then(response => {
        this.json_data = response.data.schedule_report
      }).catch(e => {
        console.log(e)
      })
    },
    onChangePage (pageOfItems) {
      // update page of items
      let mainurl = ''
      // if (this.email === 'poojasingh@quesscorp.com' || this.email === 'rinu.jaison@quesscorp.com') {
      if (this.email.split('@')[1] === 'quesscorp.com') {
        mainurl = '/dashboard/get_schedule_report_quesscorp/' + this.userInfo._id + '/' + pageOfItems[0].name
      } else {
        mainurl = '/dashboard/get_schedule_report/' + pageOfItems[0].name
      }
      const data = {
        from_date: this.startDate,
        to_date: this.endDate,
        skip: pageOfItems[0].name
      }
      // const mainurl = '/dashboard/get_schedule_report/' + pageOfItems[0].name
      axios.post(`${BaseURL}${mainurl}`, { formData: data }, this.config).then(response => {
        this.userslist = response.data.schedule_report
        this.userslistlength = response.data.schedule_report.length
        this.pageOfItems = pageOfItems[0].name + 1
        this.json_data = response.data.schedule_report
        this.json_data = this.json_data.map(item => {
          return {
            JobTittle: item.job_tittle,
            OrgName: item.org_name,
            ClientName: item.client_name,
            InterviewerName: item.interviewer_name,
            ScheduleStartTime: item.schedule_start_time,
            MeetingId: item.meeting_id,
            CandidateName: item.candidate_name,
            Status: item.status
          }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    getPostdata () {
      let mainurl = ''
      // if (this.email === 'poojasingh@quesscorp.com' || this.email === 'rinu.jaison@quesscorp.com') {
      if (this.email.split('@')[1] === 'quesscorp.com') {
        mainurl = '/dashboard/get_schedule_report_quesscorp/' + this.userInfo._id + '/0'
      } else {
        mainurl = '/dashboard/get_schedule_report/0'
      }
      const data = {
        from_date: this.startDate,
        to_date: this.endDate,
        skip: 0
      }
      // const mainurl = '/dashboard/get_schedule_report/' + '/0'
      axios.post(`${BaseURL}${mainurl}`, { formData: data }, this.config).then(response => {
        this.userslist = response.data.schedule_report
        this.userslistlength = response.data.schedule_report.length
        this.totalPages = response.data.total_count
        this.json_data = response.data.schedule_report
        for (let k = 0; k < this.totalPages; k++) {
          this.pages.push({ name: k })
        }
        this.pageOfItems = 1
        this.json_data = this.json_data.map(item => {
          return {
            JobTittle: item.job_tittle,
            OrgName: item.org_name,
            ClientName: item.client_name,
            InterviewerName: item.interviewer_name,
            ScheduleStartTime: item.schedule_start_time,
            MeetingId: item.meeting_id,
            CandidateName: item.candidate_name,
            Status: item.status
          }
        })
        console.log(response.data.total_count / 10)
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    },
    showPanels (id) {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURL + '/dashboard/get_schedule_interviewers_list/' + id, config)
        .then(response => {
          console.log('response', response.data.message)
          this.interviewersListErrorMsg = ''
          this.interviewersList = response.data.interviewers_list
          if (this.interviewersList.length === 0) {
            this.interviewersListErrorMsg = 'The selected Panels are already blocked for the same timing. Please choose different panels'
          }
          this.showInterviewersListModal = true
        }, config)
        .catch(e => {
          console.log(e)
        })
    },
    onClose () {
      this.showInterviewersListModal = false
    }
  }

}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
hr {
  margin-top: 9px;
  margin-bottom: 9px;
}
.tc {
  text-align: center;
}
.table>thead>tr>th {
    border: 2px solid #f4f4f4;
    text-align: center;
}
.table>tbody>tr>td {
    border: 2px solid #f4f4f4;
    text-align: center;
}
</style>
